module.exports = __webpack_public_path__ + "static/img/03.01b5fbe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/ustd/03.png
// module id = Y/WX
// module chunks = 1